export default __webpack_public_path__ + "static/media/shinsei.5dd73281.png";